import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

/**
 * An unknown path inside the shell.
 *
 * A real page rather than a silent redirect to the home route. A redirect makes a mistyped or
 * stale link look like the app working, and `docs/comparison-emrx.md` §7 records the sharper
 * version of the same hazard on their side: a screen that silently falls back to *something*
 * instead of refusing is indistinguishable from a screen showing the wrong thing.
 */
export function NotFoundPage() {
  const { t } = useTranslation('notFound');
  return (
    <div className="flex flex-col gap-4">
      <h1 className="m-0 text-xl font-semibold text-ink">{t('heading')}</h1>
      <p className="m-0 text-sm text-ink">{t('explanation')}</p>
      <Link to="/" className="self-start text-sm font-medium text-accent-text underline">
        {t('goToOverview')}
      </Link>
    </div>
  );
}
